import { ExtDate } from '@/helpers/date';

export default {
  params: ['yearsRange'],
  validate (value, { yearsRange }) {
    if (
      !value ||
      !value?.day ||
      !value?.month ||
      !value?.year
    ) return 'Please enter the date.';

    const { month, year = new Date().getFullYear() } = value;
    const maxDays = month ? new ExtDate(year, month - 1).getDaysInMonth() : 31;

    if (Number(value.day) < 1 || Number(value.day) > maxDays) return `The Day field must be between 1 and ${maxDays}`;

    if (value.month < 1 || value.month > 12) return 'The Month field must be between 1 and 12';

    if (value.year < yearsRange.min || value.year > yearsRange.max) return `The Year field must be between ${yearsRange.min} and ${yearsRange.max}`;

    return true;
  },
};
